export interface WizardProgressStatus {
  label: string;
  detail: string;
}

export function normalizeWizardProgressStatus(
  phaseLabel?: string,
  message?: string
): WizardProgressStatus {
  const stripTrailingDots = (value: string) => value.replace(/\.+$/, "");
  const normalizedPhase =
    typeof phaseLabel === "string" && phaseLabel.trim()
      ? phaseLabel.trim()
      : "";
  const normalizedMessage =
    typeof message === "string" && message.trim()
      ? message.trim().replace(/\s+/g, " ")
      : "";

  if (!normalizedMessage) {
    return {
      label: normalizedPhase || "Brewing",
      detail: "",
    };
  }

  if (!/\s/.test(normalizedMessage)) {
    const normalizedSingleWord = stripTrailingDots(normalizedMessage);

    if (
      normalizedPhase &&
      normalizedSingleWord.toLowerCase() === normalizedPhase.toLowerCase()
    ) {
      return {
        label: normalizedPhase,
        detail: "",
      };
    }

    return {
      label: normalizedSingleWord || normalizedMessage,
      detail: "",
    };
  }

  if (!normalizedPhase) {
    return {
      label: "Brewing",
      detail: normalizedMessage,
    };
  }

  const normalizedPhaseLower = normalizedPhase.toLowerCase();
  const normalizedMessageLower = normalizedMessage.toLowerCase();

  return {
    label: normalizedPhase,
    detail:
      normalizedMessageLower === normalizedPhaseLower ||
      normalizedMessageLower === `${normalizedPhaseLower}...`
        ? ""
        : normalizedMessage,
  };
}
